import axios from "axios";
import { logger } from "../../common/utils/logger";

export interface GoogleFont {
  label: string;
  value: string;
  kind: string;
  family: string;
  category: string;
  subsets: string[];
  variants: string[];
  version: string;
  lastModified: string;
  files: { [key: string]: string };
}

let fonts: GoogleFont[] = [];

export const GoogleServiceLib = (api_key: string) => {

  if (!google || !google.maps) {
    logger.captureWarning("Google Maps API not loaded");
  }

  const PlaceService = new google.maps.places.PlacesService(document.createElement("div"));
  const DistanceMatrix = new google.maps.DistanceMatrixService();
  const AutocompleteService = new google.maps.places.AutocompleteService();

  return {

    fonts: {
      async list(): Promise<GoogleFont[]> {
        if (fonts.length === 0) {
          const response = await axios.get(`https://www.googleapis.com/webfonts/v1/webfonts?key=${api_key}&sort=alpha`);
          if (response.data.items) {
            fonts = response.data.items.map((font: GoogleFont) => ({
              ...font,
              value: font.family,
              label: font.family,
            }));
          }
        }
        return fonts;
      },
    },

    place_get(placeId: string): Promise<google.maps.places.PlaceResult> {
      return new Promise((resolve, reject) => {
        const fields = [
          "address_component",
          "adr_address",
          "formatted_address",
          "geometry",
          "name",
          "place_id",
          "type",
        ];
        PlaceService.getDetails({ fields, placeId }, (place, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK)
            resolve(place);
          else
            reject("Error finding location");
        });
      });
    },

    autocomplete_place(opts: google.maps.places.AutocompletionRequest): Promise<google.maps.places.AutocompletePrediction[]> {
      return new Promise((resolve, reject) => {
        AutocompleteService.getPlacePredictions(opts, (predictions, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK) {
            reject("Nothing found");
          }
          else {
            resolve(predictions);
          }
        });
      });
    },

    distance_matrix(opts: google.maps.DistanceMatrixRequest): Promise<google.maps.DistanceMatrixResponse> {
      return new Promise((resolve, reject) => {
        DistanceMatrix.getDistanceMatrix(opts, (res, status) => {
          if (status === google.maps.DistanceMatrixStatus.OK) resolve(res);
          else reject(status);
        });
      });
    },

    async cords_get_current(): Promise<{ location: { lat: number; lng: number; }; accuracy: number; }> {
      const req = await axios.post(`https://www.googleapis.com/geolocation/v1/geolocate?key=${api_key}`);
      return req.data;
    },
    async timezone_from_cords(lat: number, lng: number): Promise<{ timeZoneId: string }> {
      const req = await axios.get(`https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${Date.now() / 1000}&key=${api_key}`);
      return req.data;
    },

  };

};

export type GoogleServiceType = ReturnType<typeof GoogleServiceLib>;
